import React, { Component } from 'react';
import axios from 'axios';
import Middleware from '../middle-ware/Middleware';
import { cart_quantity, fetchData, getCartProducts} from '../../../repository';

class Basketmenuitems extends Component {  

  constructor(props) {
    super(props);
    this.state = {
      num_of_products: 0,      
      isShow: true,
    }    
        
  }

  componentDidMount() {
    // if (window.location.hostname === 'localhost') {
    //   axios
    //     .get('http://127.0.0.1:8000/cart-items/')
    //     .then(res => this.setState({ items: res.data }))
    //     .catch();
    // }
    this.get_cart_basket();
  }  

  toggleBasket = () => {
    
    // console.log(this.props);		
  }

  cart = (e) => {    
    e.preventDefault();
    if (this.state.num_of_products > 0) {
      this.setState({isShow: !this.state.isShow}, this.toggleBasket)
    }        
  }  

  get_cart_basket = () => {    
    /* call only if not /en/store/checkout/thank-you/ || /fr/store/checkout/thank-you/ */
    if (window.location.pathname !== '/en/store/checkout/thank-you/' && window.location.pathname !== '/fr/store/checkout/thank-you/') {
      getCartProducts().then( (data) => {
        this.get_basket_lines(data.lines);
      })
    }
  }

  get_basket_lines = (url) => {              
    // console.log(`Basket Lines URL: ${url}`);
    fetchData(url).then( (res) => {
      let items = 0;
      // console.log(res.data);
      // console.log(res);
      // console.log(res.length);
      for (let [key, pvalue] of Object.entries(res)) {     
        items = items + pvalue.quantity;
      }
      this.setState({ num_of_products: items });
    });
    
  }


  render() {
    const num_items = this.state.num_of_products;
    return (
      <React.Fragment>
        {/* <span><a className="site-nav__secondary-menu__item" href="/store/basket/"
                                    data-keyupadded="click" data-keydownadded="click"><span
                                        className="cart-number">0</span><svg className="site-nav__cart">
                                        <use xlink:href="#icon-cart-open"></use>
                                    </svg></a></span> */}
        {/* add this class when items not empty -> site-nav__secondary-menu__item--filled */}
        
        <span id="cart" onClick={this.cart}>
          <a
            className={
              this.state.num_of_products > 0
                ? 'site-nav__secondary-menu__item site-nav__secondary-menu__item--filled'
                : 'site-nav__secondary-menu__item'
            }
            href="/store/basket/"
            data-keyupadded="click"
            data-keydownadded="click"
          >
            <span className="cart-number">{num_items}</span>            
            <svg className="site-nav__cart">
              <use href="#icon-cart-open" />
              {/* new svg icon syntax - no more xlkink:href= just href= */}
            </svg>
          </a>
        </span>         
        <Middleware 
            // openCloseBasketModal={this.openCloseBasketModal}
            updateNumOfProducts={this.updateNumOfProducts}
        />
      </React.Fragment>
    );
  }
}

export default Basketmenuitems;
